// @ts-nocheck
import React, { useState, useEffect } from 'react';
import Head from 'next/head';
import Fetch from '@/utils/Fetch';
import Storage from '@/utils/storage';
import * as Enums from '@/utils/enums';
import Helper from '@/utils/helper';
import Router, { useRouter } from 'next/router';
import { useQuery } from '@tanstack/react-query';
import ManageQuoteForm from "@/PageComponents/Quote/ManageQuoteForm";
import { createFileRoute } from '@tanstack/react-router'

function EditQuote() {
  const router = useRouter();
  const { id, tab, module, moduleID, customerID } = router.query;
 // TODO(tanstack-router): verify router.query → useParams/useSearch

  const [accessStatus, setAccessStatus] = useState(Enums.AccessStatus.None);
  const [initTab, setInitTab] = useState<any>(null);

  const { data: quote } = useQuery(
    ['quote', id],
    () => Fetch.get({ url: `/Quote/${id}` }),
    {
      enabled: !!id,
      select: (data: any) => {
        data.QuoteItems?.forEach((item: any) => {
          if ((item.UnitCostPrice === null || item.UnitCostPrice === undefined) && !!item.Inventory) {
            item.UnitCostPrice = item.Inventory.CostPrice ?? 0;
          }
        });
        return data;
      }
    }
  );

  const { data: company } = useQuery(
    ['company'],
    () => Fetch.get({ url: '/Company' })
  );

  useEffect(() => {
    const subscriptionInfo = Storage.getCookie(Enums.Cookie.subscriptionInfo);
    if (subscriptionInfo) {
      setAccessStatus(subscriptionInfo.AccessStatus);
    }
  }, []);

  useEffect(() => {
    if (accessStatus === Enums.AccessStatus.LockedWithOutAccess) {
      Helper.nextRouter(Router.replace, "/");
    }
  }, [accessStatus]);

  useEffect(() => {
    if (initTab === null && router.isReady) {
      setInitTab(tab === 'communication' ? 'Messages' : 'Quote');
    }
  }, [router.isReady, tab]);

  if (!quote || !company || initTab === null) return null;

  return (
    <>
      <Head><title>{quote?.QuoteNumber} | Quotes</title></Head>
      <div>
        <ManageQuoteForm
          initTab={initTab}
          isNew={false}
          module={module ? +module : undefined}
          moduleID={moduleID}
          customerID={customerID}
          quote={quote}
          accessStatus={accessStatus}
          company={company}
          mode={'page'}
          useTabs
        />
      </div>
    </>
  );
}

export default EditQuote;

export const Route = createFileRoute('/_authenticated/quote/$id')({ component: EditQuote })
